export default __webpack_public_path__ + "static/media/privacy-policy-title.c8b181af.webp";